<template>
  <el-dialog :title="$t('ssrManage.selSupplierTitle')" :visible="isShow" width="65%" @close="cancel('showSupplierDialog')">
    <div>
      <el-form :model="queryCondition" ref="queryCondition" label-width="140px">
        <el-row :gutter="24">
          <!-- 供应商编号/邀请码 -->
          <el-col :span="10">
            <el-form-item :label="$t('ssrManage.invitationCode')" prop="invitationSupplierCode">
              <el-input v-model="queryCondition.invitationSupplierCode" clearable></el-input>
            </el-form-item>
          </el-col>
          <!-- 供应商名称-->
          <el-col :span="10">
            <el-form-item :label="$t('ssrManage.supplierName')" prop="supplierName">
              <el-input v-model="queryCondition.supplierName" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="10">
            <el-form-item label="Category1" prop="categoryLevel1Id">
              <el-select v-model="queryCondition.categoryLevel1Id" clearable @change="changeCategory1()">
                <el-option :key="index" v-for="(item,index) in categoryList1" :label="item.name" :value="item.tmCategoryId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!--Category2-->
          <el-col :span="10">
            <el-form-item label="Category2" prop="categoryLevel2Id">
              <el-select v-model="queryCondition.categoryLevel2Id" clearable>
                <el-option :key="index" v-for="(item,index) in categoryList2" :label="item.name" :value="item.tmCategoryId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-col :span="4">
            <el-button @click="queryData(1)" type="primary">Search</el-button>
            <el-button @click="restQueryForm" type="primary">Reset</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-table :data="tableList" ref="tableList" row-key="tmSupplierId" border highlight-current-row style="margin-top:20px;">
        <el-table-column type="selection"></el-table-column>
        <!--供应商编号/邀请码-->
        <el-table-column prop="invitationCode" :label="$t('ssrManage.invitationCode')"></el-table-column>
        <!--供应商名称-->
        <el-table-column prop="supplierName" :label="$t('ssrManage.supplierName')"></el-table-column>
        <!--供应商英文名称-->
        <el-table-column prop="supplierNameEn" :label="$t('ssrManage.supplierEnName')"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
      </div>
      <div class="foot-btn" style="padding-top: 10px;text-align: center">
        <el-button type="primary" @click="confirmMethod">{{ 'Confirm' }}</el-button>
        <el-button type="primary" @click="cancel('showSupplierDialog')">{{ 'Close' }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import supplier from "@/api/supplier/supplier";
import { apiService } from "@/api/spm/spm-manage";

export default {
  extends: commonFunction,
  components: {
    IcSelect
  },
  props: {
    isShow: {
      type: Boolean,
      default: true
    },
    ssrType: String,
    createFun: {
      type: Function,
      default: function () {
      }
    }
  },
  data() {
    return {
      tableList: [],
      totalCount: 0,
      statusList: [], // 状态列表
      queryCondition: {
        pageNum: 1,
        pageSize: 15,
        auditStatus: "PASS",
        status: 1,
        supplierStatus: null,
        invitationSupplierCode: null,
        supplierName: null,
        categoryLevel1Id: null,
        categoryLevel2Id: null
      },
      categoryList1: [],
      categoryList2: [],
    };
  },
  mounted() {
    if (this.ssrType == "RFP") {
      this.queryCondition.supplierStatus = 'FORMAL';
    }
    this.queryData();
    this.getCategoryList(1)
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      supplier.resourceList(this.queryCondition).then(res => {
        this.tableList = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    getCategoryList() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        this.categoryList1 = res.data;
      });
    },
    //根据选中Category1查询Category2
    changeCategory1() {
      this.queryCondition.categoryLevel2Id = null
      this.categoryList2 = []
      apiService.findCategory({ categoryLevel: 2, pid: this.queryCondition.categoryLevel1Id }).then((res) => {
        this.categoryList2 = res.data;
      });
    },
    // 确认选中
    confirmMethod() {
      let val = this.$refs.tableList.selection;
      if (val.length > 0) {
        this.createFun(val);
        this.$refs['tableList'].clearSelection()
      } else {
        this.$message({
          type: "error",
          message: 'Please select data!'
        });
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
